import DatePicker, { DatePickerProps } from "../date-picker";
import dayjs, { Dayjs } from "dayjs";

export type OffsetDateTimeProps = Omit<
  DatePickerProps,
  "onChange" | "value"
> & {
  value?: string;
  onChange?: (value?: string | undefined) => void;
};

export function normalize(value: Dayjs | null) {
  return value?.toISOString();
}

export function OffsetDateTime({
  value,
  onChange,
  ...props
}: OffsetDateTimeProps) {
  return (
    <DatePicker
      showTime
      value={value ? dayjs(value) : undefined}
      onChange={(date) => {
        onChange?.(normalize(date));
      }}
      {...props}
    />
  );
}
